import * as ambassadorWixStoresCatalogV3InventoryItem from './stores-catalog-v3-inventory-item-inventory-items-v-3.http.js';
import * as ambassadorWixStoresCatalogV3InventoryItemTypes from './stores-catalog-v3-inventory-item-inventory-items-v-3.types.js';
import * as ambassadorWixStoresCatalogV3InventoryItemUniversalTypes from './stores-catalog-v3-inventory-item-inventory-items-v-3.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createInventoryItem(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresCatalogV3InventoryItemUniversalTypes.CreateInventoryItemRequest,
  ambassadorWixStoresCatalogV3InventoryItemTypes.CreateInventoryItemRequest,
  ambassadorWixStoresCatalogV3InventoryItemUniversalTypes.CreateInventoryItemResponse,
  ambassadorWixStoresCatalogV3InventoryItemTypes.CreateInventoryItemResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3InventoryItem.createInventoryItem(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/inventory-items',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkCreateInventoryItems(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresCatalogV3InventoryItemUniversalTypes.BulkCreateInventoryItemsRequest,
  ambassadorWixStoresCatalogV3InventoryItemTypes.BulkCreateInventoryItemsRequest,
  ambassadorWixStoresCatalogV3InventoryItemUniversalTypes.BulkCreateInventoryItemsResponse,
  ambassadorWixStoresCatalogV3InventoryItemTypes.BulkCreateInventoryItemsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3InventoryItem.bulkCreateInventoryItems(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/bulk/inventory-items/create',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getInventoryItem(): __PublicMethodMetaInfo<
  'GET',
  { inventoryItemId: string },
  ambassadorWixStoresCatalogV3InventoryItemUniversalTypes.GetInventoryItemRequest,
  ambassadorWixStoresCatalogV3InventoryItemTypes.GetInventoryItemRequest,
  ambassadorWixStoresCatalogV3InventoryItemUniversalTypes.GetInventoryItemResponse,
  ambassadorWixStoresCatalogV3InventoryItemTypes.GetInventoryItemResponse
> {
  const payload = { inventoryItemId: ':inventoryItemId' } as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3InventoryItem.getInventoryItem(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/inventory-items/{inventoryItemId}',
    pathParams: { inventoryItemId: 'inventoryItemId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateInventoryItem(): __PublicMethodMetaInfo<
  'PATCH',
  { inventoryItemId: string },
  ambassadorWixStoresCatalogV3InventoryItemUniversalTypes.UpdateInventoryItemRequest,
  ambassadorWixStoresCatalogV3InventoryItemTypes.UpdateInventoryItemRequest,
  ambassadorWixStoresCatalogV3InventoryItemUniversalTypes.UpdateInventoryItemResponse,
  ambassadorWixStoresCatalogV3InventoryItemTypes.UpdateInventoryItemResponse
> {
  const payload = { inventoryItem: { id: ':inventoryItemId' } } as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3InventoryItem.updateInventoryItem(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v3/inventory-items/{inventoryItem.id}',
    pathParams: { inventoryItemId: 'inventoryItemId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateInventoryItems(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresCatalogV3InventoryItemUniversalTypes.BulkUpdateInventoryItemsRequest,
  ambassadorWixStoresCatalogV3InventoryItemTypes.BulkUpdateInventoryItemsRequest,
  ambassadorWixStoresCatalogV3InventoryItemUniversalTypes.BulkUpdateInventoryItemsResponse,
  ambassadorWixStoresCatalogV3InventoryItemTypes.BulkUpdateInventoryItemsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3InventoryItem.bulkUpdateInventoryItems(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/bulk/inventory-items/update',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpsertInventoryItems(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresCatalogV3InventoryItemUniversalTypes.BulkUpsertInventoryItemsRequest,
  ambassadorWixStoresCatalogV3InventoryItemTypes.BulkUpsertInventoryItemsRequest,
  ambassadorWixStoresCatalogV3InventoryItemUniversalTypes.BulkUpsertInventoryItemsResponse,
  ambassadorWixStoresCatalogV3InventoryItemTypes.BulkUpsertInventoryItemsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3InventoryItem.bulkUpsertInventoryItems(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/bulk/inventory-items/upsert',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateInventoryItemsByFilter(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresCatalogV3InventoryItemUniversalTypes.BulkUpdateInventoryItemsByFilterRequest,
  ambassadorWixStoresCatalogV3InventoryItemTypes.BulkUpdateInventoryItemsByFilterRequest,
  ambassadorWixStoresCatalogV3InventoryItemUniversalTypes.BulkUpdateInventoryItemsByFilterResponse,
  ambassadorWixStoresCatalogV3InventoryItemTypes.BulkUpdateInventoryItemsByFilterResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3InventoryItem.bulkUpdateInventoryItemsByFilter(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/bulk/inventory-items/update-by-filter',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteInventoryItem(): __PublicMethodMetaInfo<
  'DELETE',
  { inventoryItemId: string },
  ambassadorWixStoresCatalogV3InventoryItemUniversalTypes.DeleteInventoryItemRequest,
  ambassadorWixStoresCatalogV3InventoryItemTypes.DeleteInventoryItemRequest,
  ambassadorWixStoresCatalogV3InventoryItemUniversalTypes.DeleteInventoryItemResponse,
  ambassadorWixStoresCatalogV3InventoryItemTypes.DeleteInventoryItemResponse
> {
  const payload = { inventoryItemId: ':inventoryItemId' } as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3InventoryItem.deleteInventoryItem(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v3/inventory-items/{inventoryItemId}',
    pathParams: { inventoryItemId: 'inventoryItemId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkDeleteInventoryItems(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresCatalogV3InventoryItemUniversalTypes.BulkDeleteInventoryItemsRequest,
  ambassadorWixStoresCatalogV3InventoryItemTypes.BulkDeleteInventoryItemsRequest,
  ambassadorWixStoresCatalogV3InventoryItemUniversalTypes.BulkDeleteInventoryItemsResponse,
  ambassadorWixStoresCatalogV3InventoryItemTypes.BulkDeleteInventoryItemsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3InventoryItem.bulkDeleteInventoryItems(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/bulk/inventory-items/delete',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkDeleteInventoryItemsByFilter(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresCatalogV3InventoryItemUniversalTypes.BulkDeleteInventoryItemsByFilterRequest,
  ambassadorWixStoresCatalogV3InventoryItemTypes.BulkDeleteInventoryItemsByFilterRequest,
  ambassadorWixStoresCatalogV3InventoryItemUniversalTypes.BulkDeleteInventoryItemsByFilterResponse,
  ambassadorWixStoresCatalogV3InventoryItemTypes.BulkDeleteInventoryItemsByFilterResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3InventoryItem.bulkDeleteInventoryItemsByFilter(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/bulk/inventory-items/delete-by-filter',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryInventoryItems(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixStoresCatalogV3InventoryItemUniversalTypes.QueryInventoryItemsRequest,
  ambassadorWixStoresCatalogV3InventoryItemTypes.QueryInventoryItemsRequest,
  ambassadorWixStoresCatalogV3InventoryItemUniversalTypes.QueryInventoryItemsResponse,
  ambassadorWixStoresCatalogV3InventoryItemTypes.QueryInventoryItemsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3InventoryItem.queryInventoryItems(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/inventory-items/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function searchInventoryItems(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixStoresCatalogV3InventoryItemUniversalTypes.SearchInventoryItemsRequest,
  ambassadorWixStoresCatalogV3InventoryItemTypes.SearchInventoryItemsRequest,
  ambassadorWixStoresCatalogV3InventoryItemUniversalTypes.SearchInventoryItemsResponse,
  ambassadorWixStoresCatalogV3InventoryItemTypes.SearchInventoryItemsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3InventoryItem.searchInventoryItems(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/inventory-items/search',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkDecrementInventoryItems(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresCatalogV3InventoryItemUniversalTypes.BulkDecrementInventoryItemsRequest,
  ambassadorWixStoresCatalogV3InventoryItemTypes.BulkDecrementInventoryItemsRequest,
  ambassadorWixStoresCatalogV3InventoryItemUniversalTypes.BulkDecrementInventoryItemsResponse,
  ambassadorWixStoresCatalogV3InventoryItemTypes.BulkDecrementInventoryItemsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3InventoryItem.bulkDecrementInventoryItems(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/bulk/inventory-items/decrement',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkIncrementInventoryItems(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresCatalogV3InventoryItemUniversalTypes.BulkIncrementInventoryItemsRequest,
  ambassadorWixStoresCatalogV3InventoryItemTypes.BulkIncrementInventoryItemsRequest,
  ambassadorWixStoresCatalogV3InventoryItemUniversalTypes.BulkIncrementInventoryItemsResponse,
  ambassadorWixStoresCatalogV3InventoryItemTypes.BulkIncrementInventoryItemsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3InventoryItem.bulkIncrementInventoryItems(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/bulk/inventory-items/increment',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkDecrementInventoryItemsByVariantAndLocation(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresCatalogV3InventoryItemUniversalTypes.BulkDecrementInventoryItemsByVariantAndLocationRequest,
  ambassadorWixStoresCatalogV3InventoryItemTypes.BulkDecrementInventoryItemsByVariantAndLocationRequest,
  ambassadorWixStoresCatalogV3InventoryItemUniversalTypes.BulkDecrementInventoryItemsByVariantAndLocationResponse,
  ambassadorWixStoresCatalogV3InventoryItemTypes.BulkDecrementInventoryItemsByVariantAndLocationResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3InventoryItem.bulkDecrementInventoryItemsByVariantAndLocation(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/bulk/inventory-items/decrement-by-variant-and-location',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkIncrementInventoryItemsByVariantAndLocation(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresCatalogV3InventoryItemUniversalTypes.BulkIncrementInventoryItemsByVariantAndLocationRequest,
  ambassadorWixStoresCatalogV3InventoryItemTypes.BulkIncrementInventoryItemsByVariantAndLocationRequest,
  ambassadorWixStoresCatalogV3InventoryItemUniversalTypes.BulkIncrementInventoryItemsByVariantAndLocationResponse,
  ambassadorWixStoresCatalogV3InventoryItemTypes.BulkIncrementInventoryItemsByVariantAndLocationResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3InventoryItem.bulkIncrementInventoryItemsByVariantAndLocation(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/bulk/inventory-items/increment-by-variant-and-location',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkSetOrAdjustInventoryItemsByFilter(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresCatalogV3InventoryItemUniversalTypes.BulkSetOrAdjustInventoryItemsByFilterRequest,
  ambassadorWixStoresCatalogV3InventoryItemTypes.BulkSetOrAdjustInventoryItemsByFilterRequest,
  ambassadorWixStoresCatalogV3InventoryItemUniversalTypes.BulkSetOrAdjustInventoryItemsByFilterResponse,
  ambassadorWixStoresCatalogV3InventoryItemTypes.BulkSetOrAdjustInventoryItemsByFilterResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3InventoryItem.bulkSetOrAdjustInventoryItemsByFilter(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/bulk/inventory-items/set-or-adjust-by-filter',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkAdjustInventoryItemsByFilter(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresCatalogV3InventoryItemUniversalTypes.BulkAdjustInventoryItemsByFilterRequest,
  ambassadorWixStoresCatalogV3InventoryItemTypes.BulkAdjustInventoryItemsByFilterRequest,
  ambassadorWixStoresCatalogV3InventoryItemUniversalTypes.BulkAdjustInventoryItemsByFilterResponse,
  ambassadorWixStoresCatalogV3InventoryItemTypes.BulkAdjustInventoryItemsByFilterResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3InventoryItem.bulkAdjustInventoryItemsByFilter(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/bulk/inventory-items/adjust-by-filter',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkCreateInventoryItemsByVariantFilter(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresCatalogV3InventoryItemUniversalTypes.BulkCreateInventoryItemsByVariantFilterRequest,
  ambassadorWixStoresCatalogV3InventoryItemTypes.BulkCreateInventoryItemsByVariantFilterRequest,
  ambassadorWixStoresCatalogV3InventoryItemUniversalTypes.BulkCreateInventoryItemsByVariantFilterResponse,
  ambassadorWixStoresCatalogV3InventoryItemTypes.BulkCreateInventoryItemsByVariantFilterResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3InventoryItem.bulkCreateInventoryItemsByVariantFilter(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/bulk/inventory-items/create-by-variant-filter',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  InventoryItem as InventoryItemOriginal,
  InventoryItemTrackingMethodOneOf as InventoryItemTrackingMethodOneOfOriginal,
  AvailabilityStatus as AvailabilityStatusOriginal,
  AvailabilityStatusWithLiterals as AvailabilityStatusWithLiteralsOriginal,
  PreorderInfo as PreorderInfoOriginal,
  Product as ProductOriginal,
  Brand as BrandOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  InvalidateCache as InvalidateCacheOriginal,
  InvalidateCacheGetByOneOf as InvalidateCacheGetByOneOfOriginal,
  App as AppOriginal,
  Page as PageOriginal,
  URI as URIOriginal,
  File as FileOriginal,
  CustomTag as CustomTagOriginal,
  Pages as PagesOriginal,
  URIs as URIsOriginal,
  BulkInventoryItemAction as BulkInventoryItemActionOriginal,
  EventType as EventTypeOriginal,
  EventTypeWithLiterals as EventTypeWithLiteralsOriginal,
  CreateInventoryItemRequest as CreateInventoryItemRequestOriginal,
  CreateInventoryItemResponse as CreateInventoryItemResponseOriginal,
  BulkCreateInventoryItemsRequest as BulkCreateInventoryItemsRequestOriginal,
  BulkCreateInventoryItemsResponse as BulkCreateInventoryItemsResponseOriginal,
  V3BulkInventoryItemResult as V3BulkInventoryItemResultOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  GetInventoryItemRequest as GetInventoryItemRequestOriginal,
  GetInventoryItemResponse as GetInventoryItemResponseOriginal,
  UpdateInventoryItemRequest as UpdateInventoryItemRequestOriginal,
  ReasonType as ReasonTypeOriginal,
  ReasonTypeWithLiterals as ReasonTypeWithLiteralsOriginal,
  UpdateInventoryItemResponse as UpdateInventoryItemResponseOriginal,
  InventoryItemStockStatusUpdatedEvent as InventoryItemStockStatusUpdatedEventOriginal,
  InventoryItemUpdatedWithReason as InventoryItemUpdatedWithReasonOriginal,
  BulkUpdateInventoryItemsRequest as BulkUpdateInventoryItemsRequestOriginal,
  MaskedInventoryItem as MaskedInventoryItemOriginal,
  BulkUpdateInventoryItemsResponse as BulkUpdateInventoryItemsResponseOriginal,
  BulkUpsertInventoryItemsRequest as BulkUpsertInventoryItemsRequestOriginal,
  BulkUpsertInventoryItemsResponse as BulkUpsertInventoryItemsResponseOriginal,
  BulkUpsertInventoryItemResult as BulkUpsertInventoryItemResultOriginal,
  BulkUpdateInventoryItemsByFilterRequest as BulkUpdateInventoryItemsByFilterRequestOriginal,
  SearchDetails as SearchDetailsOriginal,
  Mode as ModeOriginal,
  ModeWithLiterals as ModeWithLiteralsOriginal,
  BulkUpdateInventoryItemsByFilterResponse as BulkUpdateInventoryItemsByFilterResponseOriginal,
  DeleteInventoryItemRequest as DeleteInventoryItemRequestOriginal,
  DeleteInventoryItemResponse as DeleteInventoryItemResponseOriginal,
  BulkDeleteInventoryItemsRequest as BulkDeleteInventoryItemsRequestOriginal,
  BulkDeleteInventoryItemsResponse as BulkDeleteInventoryItemsResponseOriginal,
  BulkInventoryItemResult as BulkInventoryItemResultOriginal,
  BulkDeleteInventoryItemsByFilterRequest as BulkDeleteInventoryItemsByFilterRequestOriginal,
  BulkDeleteInventoryItemsByFilterResponse as BulkDeleteInventoryItemsByFilterResponseOriginal,
  QueryInventoryItemsRequest as QueryInventoryItemsRequestOriginal,
  QueryV2 as QueryV2Original,
  QueryV2PagingMethodOneOf as QueryV2PagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  Paging as PagingOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryInventoryItemsResponse as QueryInventoryItemsResponseOriginal,
  PlatformPagingMetadataV2 as PlatformPagingMetadataV2Original,
  CommonCursors as CommonCursorsOriginal,
  SearchInventoryItemsRequest as SearchInventoryItemsRequestOriginal,
  CursorSearch as CursorSearchOriginal,
  CursorSearchPagingMethodOneOf as CursorSearchPagingMethodOneOfOriginal,
  Aggregation as AggregationOriginal,
  AggregationKindOneOf as AggregationKindOneOfOriginal,
  RangeBucket as RangeBucketOriginal,
  SortType as SortTypeOriginal,
  SortTypeWithLiterals as SortTypeWithLiteralsOriginal,
  SortDirection as SortDirectionOriginal,
  SortDirectionWithLiterals as SortDirectionWithLiteralsOriginal,
  MissingValues as MissingValuesOriginal,
  MissingValuesWithLiterals as MissingValuesWithLiteralsOriginal,
  IncludeMissingValuesOptions as IncludeMissingValuesOptionsOriginal,
  ScalarType as ScalarTypeOriginal,
  ScalarTypeWithLiterals as ScalarTypeWithLiteralsOriginal,
  ValueAggregation as ValueAggregationOriginal,
  ValueAggregationOptionsOneOf as ValueAggregationOptionsOneOfOriginal,
  NestedAggregationType as NestedAggregationTypeOriginal,
  NestedAggregationTypeWithLiterals as NestedAggregationTypeWithLiteralsOriginal,
  RangeAggregation as RangeAggregationOriginal,
  ScalarAggregation as ScalarAggregationOriginal,
  DateHistogramAggregation as DateHistogramAggregationOriginal,
  Interval as IntervalOriginal,
  IntervalWithLiterals as IntervalWithLiteralsOriginal,
  NestedAggregationItem as NestedAggregationItemOriginal,
  NestedAggregationItemKindOneOf as NestedAggregationItemKindOneOfOriginal,
  AggregationType as AggregationTypeOriginal,
  AggregationTypeWithLiterals as AggregationTypeWithLiteralsOriginal,
  NestedAggregation as NestedAggregationOriginal,
  GroupByAggregation as GroupByAggregationOriginal,
  GroupByAggregationKindOneOf as GroupByAggregationKindOneOfOriginal,
  SearchInventoryItemsResponse as SearchInventoryItemsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  AggregationData as AggregationDataOriginal,
  ValueAggregationResult as ValueAggregationResultOriginal,
  RangeAggregationResult as RangeAggregationResultOriginal,
  NestedAggregationResults as NestedAggregationResultsOriginal,
  NestedAggregationResultsResultOneOf as NestedAggregationResultsResultOneOfOriginal,
  ValueResults as ValueResultsOriginal,
  RangeResults as RangeResultsOriginal,
  AggregationResultsScalarResult as AggregationResultsScalarResultOriginal,
  NestedValueAggregationResult as NestedValueAggregationResultOriginal,
  ValueResult as ValueResultOriginal,
  RangeResult as RangeResultOriginal,
  ScalarResult as ScalarResultOriginal,
  NestedResultValue as NestedResultValueOriginal,
  NestedResultValueResultOneOf as NestedResultValueResultOneOfOriginal,
  Results as ResultsOriginal,
  DateHistogramResult as DateHistogramResultOriginal,
  GroupByValueResults as GroupByValueResultsOriginal,
  DateHistogramResults as DateHistogramResultsOriginal,
  NestedResults as NestedResultsOriginal,
  AggregationResults as AggregationResultsOriginal,
  AggregationResultsResultOneOf as AggregationResultsResultOneOfOriginal,
  SearchInventoryItemsWithOffsetRequest as SearchInventoryItemsWithOffsetRequestOriginal,
  OffsetSearch as OffsetSearchOriginal,
  OffsetSearchPagingMethodOneOf as OffsetSearchPagingMethodOneOfOriginal,
  SearchInventoryItemsWithOffsetResponse as SearchInventoryItemsWithOffsetResponseOriginal,
  PagingMetadata as PagingMetadataOriginal,
  BulkDecrementInventoryItemsRequest as BulkDecrementInventoryItemsRequestOriginal,
  DecrementDataById as DecrementDataByIdOriginal,
  BulkDecrementInventoryItemsResponse as BulkDecrementInventoryItemsResponseOriginal,
  BulkIncrementInventoryItemsRequest as BulkIncrementInventoryItemsRequestOriginal,
  IncrementDataById as IncrementDataByIdOriginal,
  BulkIncrementInventoryItemsResponse as BulkIncrementInventoryItemsResponseOriginal,
  BulkDecrementInventoryItemsByVariantAndLocationRequest as BulkDecrementInventoryItemsByVariantAndLocationRequestOriginal,
  DecrementDataByVariantAndLocation as DecrementDataByVariantAndLocationOriginal,
  BulkDecrementInventoryItemsByVariantAndLocationResponse as BulkDecrementInventoryItemsByVariantAndLocationResponseOriginal,
  BulkIncrementInventoryItemsByVariantAndLocationRequest as BulkIncrementInventoryItemsByVariantAndLocationRequestOriginal,
  IncrementDataByVariantAndLocation as IncrementDataByVariantAndLocationOriginal,
  BulkIncrementInventoryItemsByVariantAndLocationResponse as BulkIncrementInventoryItemsByVariantAndLocationResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  RecloneSiteRequest as RecloneSiteRequestOriginal,
  RecloneSiteResponse as RecloneSiteResponseOriginal,
  BulkSetOrAdjustInventoryItemsByFilterRequest as BulkSetOrAdjustInventoryItemsByFilterRequestOriginal,
  AdjustInventoryAction as AdjustInventoryActionOriginal,
  AdjustInventoryActionActionOneOf as AdjustInventoryActionActionOneOfOriginal,
  BulkSetOrAdjustInventoryItemsByFilterResponse as BulkSetOrAdjustInventoryItemsByFilterResponseOriginal,
  BulkAdjustInventoryItemsByFilterRequest as BulkAdjustInventoryItemsByFilterRequestOriginal,
  BulkAdjustInventoryItemsByFilterResponse as BulkAdjustInventoryItemsByFilterResponseOriginal,
  BulkCreateInventoryItemsByVariantFilterRequest as BulkCreateInventoryItemsByVariantFilterRequestOriginal,
  InventoryCreationData as InventoryCreationDataOriginal,
  BulkCreateInventoryItemsByVariantFilterResponse as BulkCreateInventoryItemsByVariantFilterResponseOriginal,
  CatalogRollbackRequested as CatalogRollbackRequestedOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  CreateInventoryItemApplicationErrors as CreateInventoryItemApplicationErrorsOriginal,
  CreateInventoryItemValidationErrors as CreateInventoryItemValidationErrorsOriginal,
  BulkCreateInventoryItemsApplicationErrors as BulkCreateInventoryItemsApplicationErrorsOriginal,
  BulkCreateInventoryItemsValidationErrors as BulkCreateInventoryItemsValidationErrorsOriginal,
  UpdateInventoryItemApplicationErrors as UpdateInventoryItemApplicationErrorsOriginal,
  BulkUpdateInventoryItemsApplicationErrors as BulkUpdateInventoryItemsApplicationErrorsOriginal,
  BulkUpsertInventoryItemsApplicationErrors as BulkUpsertInventoryItemsApplicationErrorsOriginal,
  BulkUpdateInventoryItemsByFilterApplicationErrors as BulkUpdateInventoryItemsByFilterApplicationErrorsOriginal,
  BulkDecrementInventoryItemsApplicationErrors as BulkDecrementInventoryItemsApplicationErrorsOriginal,
  BulkIncrementInventoryItemsApplicationErrors as BulkIncrementInventoryItemsApplicationErrorsOriginal,
  BulkDecrementInventoryItemsByVariantAndLocationApplicationErrors as BulkDecrementInventoryItemsByVariantAndLocationApplicationErrorsOriginal,
  BulkIncrementInventoryItemsByVariantAndLocationApplicationErrors as BulkIncrementInventoryItemsByVariantAndLocationApplicationErrorsOriginal,
  BulkSetOrAdjustInventoryItemsByFilterApplicationErrors as BulkSetOrAdjustInventoryItemsByFilterApplicationErrorsOriginal,
  BulkAdjustInventoryItemsByFilterApplicationErrors as BulkAdjustInventoryItemsByFilterApplicationErrorsOriginal,
} from './stores-catalog-v3-inventory-item-inventory-items-v-3.types.js';
